// src/components/upload/FileValidator.jsx
import React from 'react';
import { CheckCircle, AlertTriangle, X } from 'lucide-react';

const FileValidator = ({ file, validationRules = {} }) => {
  const {
    maxSize = 10 * 1024 * 1024, // 10MB par défaut
    allowedTypes = ['text/csv', 'application/json', 'text/plain'],
    maxFiles = 5
  } = validationRules;

  const validateFile = (file) => {
    const errors = [];
    const warnings = [];

    // Validation de la taille
    if (file.size > maxSize) {
      errors.push(`La taille du fichier dépasse la limite de ${Math.round(maxSize / 1024 / 1024)}MB`);
    }

    // Validation du type
    if (!allowedTypes.includes(file.type)) {
      errors.push(`Type de fichier non autorisé. Types acceptés: ${allowedTypes.join(', ')}`);
    }

    // Validation du nom de fichier
    if (file.name.length > 255) {
      warnings.push('Le nom du fichier est très long');
    }

    return {
      isValid: errors.length === 0,
      errors,
      warnings
    };
  };

  const validation = validateFile(file);

  const getIcon = () => {
    if (validation.isValid) {
      return <CheckCircle className="h-5 w-5 text-green-500" />;
    } else {
      return <AlertTriangle className="h-5 w-5 text-red-500" />;
    }
  };

  return (
    <div className="flex items-center space-x-2 p-2 border rounded">
      {getIcon()}
      <div className="flex-1">
        <div className="text-sm font-medium">{file.name}</div>
        <div className="text-xs text-gray-500">
          {(file.size / 1024).toFixed(1)} KB
        </div>
        
        {validation.errors.map((error, index) => (
          <div key={index} className="text-xs text-red-600 mt-1">
            {error}
          </div>
        ))}
        
        {validation.warnings.map((warning, index) => (
          <div key={index} className="text-xs text-yellow-600 mt-1">
            {warning}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FileValidator;
